module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABQklEQVQ4jaXUv2oVYRAF8LMh4FNYmT9a2NpJhHiDsbPyISzER0jlMxgIWNvZpYjYqBfsRdBN4Rskooia688ic3HZrGFvcmCamTnnm+GbmSADtoln+Iyf+IFDPMcETZ/TF7iO1/6hxSvsl9Acb7BWnDt43BXZwFfMsFei/YfWqtIZjnEbLzGbJ9zAUQXv/qfdrk3wvTgflLPBFCe4P0IkuImdTqtSFah2xohMnMXv5SQPc4qnGYe3SZ4kudLxfWrQJpFkdaTQIJaSXE3y5RIaj5K8WL5MFYUHSW41OEzyJxdvrU1yspTkXZKVskWxkuRakvfBvQW/v2t7xd3qD+T2AiLbxZmi6a7IcY38mBXZrNwjtZPnLe36gMB6xWaVuzGPDZ2RaWf0WxyUtR3/VO86DJXdYAu7+Ihv+OX0Hu1W7Mxh+wuvm+Ow11K8ugAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/search/refresh.png
// module id = OyCQ
// module chunks = 1